"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramInfoDto = exports.GetUsersProgramsQueryDto = exports.ByPlatformDto = exports.SimpleProgramDto = exports.UpdateProgramOptionsDto = exports.UpdateProgramDto = exports.CreateProgramDto = exports.BaseProgramDto = exports.ProgramHighlightDto = exports.UpdateProgramStatusDto = exports.FindProgramFiltersDto = exports.ByProgramDto = exports.ByProgramIdDto = exports.FindProgramsByProgramTypeAndOrganizationIdDto = exports.FindProgramsByOrganizationIdDto = exports.GetOrganizationRelatedProgramsDto = exports.RelatedProgramsDto = exports.GetOrganizationProgramsDto = exports.FindOrganizationProgramsDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class FindOrganizationProgramsDto {
}
exports.FindOrganizationProgramsDto = FindOrganizationProgramsDto;
class GetOrganizationProgramsDto extends general_dto_1.PaginationQuery {
}
exports.GetOrganizationProgramsDto = GetOrganizationProgramsDto;
class RelatedProgramsDto {
}
exports.RelatedProgramsDto = RelatedProgramsDto;
class GetOrganizationRelatedProgramsDto {
}
exports.GetOrganizationRelatedProgramsDto = GetOrganizationRelatedProgramsDto;
class FindProgramsByOrganizationIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.FindProgramsByOrganizationIdDto = FindProgramsByOrganizationIdDto;
class FindProgramsByProgramTypeAndOrganizationIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.FindProgramsByProgramTypeAndOrganizationIdDto = FindProgramsByProgramTypeAndOrganizationIdDto;
class ByProgramIdDto extends organization_dto_1.OptionalOrganizationIdDto {
}
exports.ByProgramIdDto = ByProgramIdDto;
class ByProgramDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByProgramDto = ByProgramDto;
class FindProgramFiltersDto {
}
exports.FindProgramFiltersDto = FindProgramFiltersDto;
class UpdateProgramStatusDto extends ByProgramIdDto {
}
exports.UpdateProgramStatusDto = UpdateProgramStatusDto;
class ProgramHighlightDto {
}
exports.ProgramHighlightDto = ProgramHighlightDto;
class BaseProgramDto {
}
exports.BaseProgramDto = BaseProgramDto;
class CreateProgramDto extends BaseProgramDto {
}
exports.CreateProgramDto = CreateProgramDto;
class UpdateProgramDto extends BaseProgramDto {
}
exports.UpdateProgramDto = UpdateProgramDto;
class UpdateProgramOptionsDto {
}
exports.UpdateProgramOptionsDto = UpdateProgramOptionsDto;
class SimpleProgramDto extends general_dto_1.IdAndNameDto {
}
exports.SimpleProgramDto = SimpleProgramDto;
class ByPlatformDto {
}
exports.ByPlatformDto = ByPlatformDto;
class GetUsersProgramsQueryDto extends general_dto_1.PaginationQuery {
}
exports.GetUsersProgramsQueryDto = GetUsersProgramsQueryDto;
class ProgramInfoDto {
}
exports.ProgramInfoDto = ProgramInfoDto;
//# sourceMappingURL=program.dto.js.map